import {FC} from 'react'
import {Link, useParams} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, KTIcon, WithChildren} from '../../../../helpers'
import {useLayout} from '../../../core'
import secureLocalStorage from 'react-secure-storage'
import {FindPodIdByCode} from '../../../../../app/modules/FindPodIdByPodCode'
import '../index.css'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'
import CryptoJS from 'crypto-js'

const secretKey: any = process.env.REACT_APP_REQUEST_SIGN_SECRET_KEY

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  isExternal?: boolean
}

interface UserInfo {
  user_id: string
  auth_token: string
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  isExternal = false,
}) => {
  const {id} = useParams()
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, to)
  const {config} = useLayout()
  const {app} = config
  const podId = FindPodIdByCode()
  const userInfo = secureLocalStorage.getItem('user_info')
  let user_id = ''
  let auth_token = ''
  if (userInfo) {
    ;({user_id, auth_token} = userInfo as UserInfo)
  }

  const payload = {
    pod_id: podId,
    user_id,
    auth_token,
    pod_code: id,
  }

  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(payload), secretKey).toString()
  const encoded = encodeURIComponent(encrypted)

  const url = `${process.env.REACT_APP_REQUEST_SIGN_PATH}/request-signatures?data=${encoded}`

  return (
    <div className='d-flex flex-column align-items-center'>
      {isExternal ? (
        <Tippy content={title}>
          <a
            href={url}
            // href={`http://localhost:3011/request-signatures?p=${podId}&u=${user_id}&t=${auth_token}&c=${id}`}
            // target='_blank'
            className={`d-flex justify-content-center align-items-center text-decoration-none pt-1 ${
              isActive ? 'nav-active-menu-item' : 'text-muted'
            }`}
          >
            {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
              <span className={`btn btn-icon bg-transparent btn-sm my-2`}>
                <KTIcon iconName={icon} className={`fs-2 ${isActive ? 'text-primary' : ''}`} />
              </span>
            )}
          </a>
        </Tippy>
      ) : (
        <Tippy content={title}>
          <Link
            to={to}
            className={`w-100 d-flex justify-content-center align-items-center text-decoration-none ${
              isActive ? 'nav-active-menu-item' : 'text-muted'
            }`}
          >
            {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
              <span className='btn btn-icon bg-transparent btn-sm my-2'>
                <KTIcon
                  iconName={icon}
                  className={`fs-2 ${isActive ? 'text-white' : 'text-muted'}`}
                />
              </span>
            )}
          </Link>
        </Tippy>
      )}
      {children}
    </div>
  )
}

export {SidebarMenuItem}
